import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home";
import Referencias from "../views/Referencias";

import topico_01 from "@/views/topicos/topico_01/index.vue";
import Atividade_1_Topico_1 from "@/views/topicos/topico_01/atividades/Atividade_1.vue";

import topico_02 from "@/views/topicos/topico_02/index.vue";

import topico_03 from "@/views/topicos/topico_03/index.vue";
import Atividade_1_Topico_3 from "@/views/topicos/topico_03/atividades/Atividade_1.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/topico-1",
    name: "NORMAS GERAIS DE CIRCULAÇÃO E CONDUTA",
    component: topico_01,
  },
  {
    path: "/topico-1-atividade-1",
    name: "Tópico 1 - Atividade 1",
    component: Atividade_1_Topico_1,
  },
  {
    path: "/topico-2",
    name: "SINALIZAÇÃO VIÁRIA",
    component: topico_02,
  },
  {
    path: "/topico-3",
    name: "DIREITOS E DEVERES DO CONDUTOR",
    component: topico_03,
  },
  {
    path: "/topico-3-atividade-1",
    name: "Tópico 3 - Atividade 1",
    component: Atividade_1_Topico_3,
  },
  {
    path: "/referencias",
    name: "Referências",
    component: Referencias,
  },

];

const router = new VueRouter({
  routes,
  //mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.afterEach(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});

//salvar ultima pagina visitada ao reabrir o site
router.afterEach((to) => {
  localStorage.setItem("brisanet-modulo-1", to.name);
});

let isFirstTransition = true;

router.beforeEach((to, from, next) => {

  const lastRouteName = localStorage.getItem("brisanet-modulo-1");
  const shouldRedirect = Boolean(
    to.name === "Home" && lastRouteName && isFirstTransition
  );

  if (shouldRedirect && to.name !== from.name) {
    isFirstTransition = false;
    next({ name: lastRouteName });
    //console.log("pegou o localstorage");
    //this.$store.commit("TOGGLE_WELCOME_BACK");
  } else {
    next();
    //console.log("Navegou normal sem reabrir a aba");
  }

});

export default router;
